const FOLDER_NAME_PATTERN = /^[a-zA-Z0-9][a-zA-Z0-9 _-]*$/

export const isValidFolderName = (name: string): boolean => FOLDER_NAME_PATTERN.test(name)

export const FOLDER_NAME_ERROR_MESSAGE =
  'Folder name can only contain letters, numbers, spaces, underscores, and dashes.'
